<template>
  <div>
    <el-table :data="list">
      <el-table-column prop="tenantName" label="租户"></el-table-column>
      <el-table-column label="上账时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="userId" label="总户 userId"></el-table-column>
      <el-table-column prop="type" label="钱包"></el-table-column>
      <el-table-column prop="coin" label="币种"></el-table-column>
      <el-table-column prop="availableChange" label="上账金额"></el-table-column>
      <el-table-column prop="openUserId" label="操作人"></el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handleCurrentChange"
    ></pagination>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Pagination from "components/pagination";

export default {
  name: "transferInnerList",
  computed: {
    ...mapState("transferInner", ["totalCount", "pagination"]),
    ...mapGetters("transferInner", ["list"]),
  },
  components: {
    Pagination,
  },
  methods: {
    handleCurrentChange(pagination) {
      this.$emit("refresh", pagination);
    },
  },
};
</script>
